<script>
import Layout from "@/router/layouts/auth";
import { api } from "@/state/services";
import { required, email } from "vuelidate/lib/validators";
import { checkCpf } from "@/state/validations/register";

export default {
  components: { Layout },

    data() {
        return {
        cepManual: false,
        loading: false,

        form: {
            cnpj: "",
            razao_social: "",
            email: "",
            whatsapp: "",
            tipo_regional: "",

            zipcode: "",
            address: "",
            number: "",
            complement: "",
            district: "",
            city: "",
            state: "",

            nome_regional: "",
            cpf_regional: "",
            estado_civil: "",

            nome_conjuge: "",
            cpf_conjuge: "",
            hierarquia_ok: null // true ou false
        }
        };
    },

    validations: {
        form: {
            cnpj: { required },
            razao_social: { required },
            email: { required, email },
            whatsapp: { required },
            tipo_regional: { required },

            zipcode: { required },
            address: { required },
            number: { required },
            district: { required },
            city: { required },
            state: { required },

            nome_regional: { required },
            cpf_regional: { required, checkCpf },
            estado_civil: { required },

            // 🔒 AJUSTE AQUI (SEM QUEBRAR)
            nome_conjuge: {
            required(value, parent) {
                // parent === form
                if (!parent || parent.estado_civil !== "casado") return true;
                return !!value;
            }
            },

            cpf_conjuge: {
            required(value, parent) {
                if (!parent || parent.estado_civil !== "casado") return true;
                return !!value;
            },
            checkCpf
            },

            hierarquia_ok: {
            required(value) {
                return value === true || value === false;
            }
            }
        }
    },

  methods: {
    loadData() {
      api.get("user/update-profile").then(res => {
        if (res.data.data) {
          Object.assign(this.form, res.data.data);
        }
      });
    },

    searchCep() {
      if (this.form.zipcode.length !== 9) return;

      const cep = this.form.zipcode.replace(/\D/g, "");

      api.get(`https://cep.m2n.com.br/${cep}`)
        .then(res => {
          if (res.data.status === "error") {
            this.cepManual = true;
            return;
          }

          this.cepManual = false;
          this.form.address = res.data.address || "";
          this.form.district = res.data.district || "";
          this.form.city = res.data.city || "";
          this.form.state = res.data.state || "";
        })
        .catch(() => {
          this.cepManual = true;
        });
    },

    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;

      api.post("user/update-profile", this.form)
        .then(res => {
          if (res.data.status === "success") {
            this.$toast.success(res.data.message);

            // 👉 redireciona para o início
            setTimeout(() => {
              this.$router.push("/");
            }, 500);
          } else {
            this.$toast.error(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },

  mounted() {
    this.loadData();
  }
};
</script>

<template>
  <Layout>
    <div class="container py-4">

        <!-- AVISO DE ATUALIZAÇÃO CADASTRAL -->
        <div class="container py-4">
        <div class="alert alert-warning border-left-warning shadow-sm">
            <h5 class="mb-3 font-weight-bold">
            Prezado(a) Regional,
            </h5>

            <p>
            Solicitamos, por gentileza, a atualização de suas informações cadastrais em nosso sistema.
            </p>

            <p>
            Informamos que o acesso às plataformas e aos sistemas será liberado
            <strong>somente após o envio e validação das informações solicitadas</strong>,
            medida necessária para garantir a conformidade dos dados e a segurança dos
            processos internos.
            </p>

            <p>
            Pedimos que, por gentileza, atualize o quanto antes.
            </p>

            <p class="mb-0">
            Permanecemos à disposição para eventuais esclarecimentos.
            </p>

            <hr>

            <p class="mb-0 font-weight-bold">
            Atenciosamente,<br>
            Sales Teams
            </p>
        </div>
        </div>


      <!-- DADOS PESSOA JURÍDICA -->
      <div class="card mb-4">
        <div class="card-header">Dados Pessoa Jurídica</div>
        <div class="card-body">

          <b-form-group label="CNPJ">
            <b-form-input
              v-model="form.cnpj"
              v-mask="'##.###.###/####-##'"
              :class="{ 'is-invalid': $v.form.cnpj.$error }"
            />
          </b-form-group>

          <b-form-group label="Razão Social">
            <b-form-input
              v-model="form.razao_social"
              :class="{ 'is-invalid': $v.form.razao_social.$error }"
            />
          </b-form-group>

          <b-form-group label="E-mail">
            <b-form-input
              v-model="form.email"
              :class="{ 'is-invalid': $v.form.email.$error }"
            />
          </b-form-group>

          <b-form-group label="WhatsApp">
            <b-form-input
              v-model="form.whatsapp"
              v-mask="'(##) #####-####'"
              :class="{ 'is-invalid': $v.form.whatsapp.$error }"
            />
          </b-form-group>

          <b-form-group label="Tipo de Regional">
            <select
              class="custom-select"
              v-model="form.tipo_regional"
              :class="{ 'is-invalid': $v.form.tipo_regional.$error }"
            >
              <option value="">–</option>
              <option value="regional_home_office">Regional Home Office</option>
              <option value="regional_executiva">Regional Executiva</option>
              <option value="gerente_regional">Gerente Regional</option>
              <option value="gerente_master">Gerente Master</option>
              <option value="diretor">Diretor</option>
            </select>
          </b-form-group>

        </div>
      </div>

      <!-- ENDEREÇO -->
      <div class="card mb-4">
        <div class="card-header">Endereço</div>
        <div class="card-body">

          <b-form-group label="CEP">
            <b-form-input
              v-model="form.zipcode"
              v-mask="'#####-###'"
              @blur="searchCep"
              :class="{ 'is-invalid': $v.form.zipcode.$error }"
            />
          </b-form-group>

          <b-form-group label="Endereço">
            <b-form-input
              v-model="form.address"
              :class="{ 'is-invalid': $v.form.address.$error }"
            />
          </b-form-group>

          <b-form-group label="Número">
            <b-form-input
              v-model="form.number"
              :class="{ 'is-invalid': $v.form.number.$error }"
            />
          </b-form-group>

          <b-form-group label="Complemento">
            <b-form-input v-model="form.complement" />
          </b-form-group>

          <b-form-group label="Bairro">
            <b-form-input
              v-model="form.district"
              :class="{ 'is-invalid': $v.form.district.$error }"
            />
          </b-form-group>

          <b-form-group label="Cidade">
            <b-form-input
              v-model="form.city"
              :readonly="!cepManual"
              :class="[
                cepManual ? '' : 'bg-soft-info',
                { 'is-invalid': $v.form.city.$error }
              ]"
            />
          </b-form-group>

          <b-form-group label="Estado">
            <b-form-input
              v-model="form.state"
              v-mask="'XX'"
              :readonly="!cepManual"
              :class="[
                cepManual ? '' : 'bg-soft-info',
                { 'is-invalid': $v.form.state.$error }
              ]"
            />
          </b-form-group>

        </div>
      </div>

      <!-- DADOS PESSOA FÍSICA -->
      <div class="card mb-4">
        <div class="card-header">Dados Pessoa Física</div>
        <div class="card-body">

          <b-form-group label="Nome do Responsável da Regional">
            <b-form-input
              v-model="form.nome_regional"
              :class="{ 'is-invalid': $v.form.nome_regional.$error }"
            />
          </b-form-group>

          <b-form-group label="CPF do Regional">
            <b-form-input
              v-model="form.cpf_regional"
              v-mask="'###.###.###-##'"
              :class="{ 'is-invalid': $v.form.cpf_regional.$error }"
            />
          </b-form-group>

          <b-form-group label="Estado Civil">
            <select
              class="custom-select"
              v-model="form.estado_civil"
              :class="{ 'is-invalid': $v.form.estado_civil.$error }"
            >
              <option value="">–</option>
              <option value="solteiro">Solteiro(a)</option>
              <option value="casado">Casado(a)</option>
              <option value="divorciado">Divorciado(a)</option>
              <option value="viuvo">Viúvo(a)</option>
              <option value="separado">Separado(a)</option>
            </select>
          </b-form-group>

          <template v-if="form.estado_civil === 'casado'">
            <b-form-group label="Nome do Cônjuge">
              <b-form-input
                v-model="form.nome_conjuge"
                :class="{ 'is-invalid': $v.form.nome_conjuge.$error }"
              />
            </b-form-group>

            <b-form-group label="CPF do Cônjuge">
              <b-form-input
                v-model="form.cpf_conjuge"
                v-mask="'###.###.###-##'"
                :class="{ 'is-invalid': $v.form.cpf_conjuge.$error }"
              />
            </b-form-group>
          </template>

        </div>
      </div>
      <!-- VALIDAÇÃO DE HIERARQUIA -->
      <div class="card mb-4">
        <div class="card-header font-weight-bold">
            Validação de Hierarquia
        </div>

        <div class="card-body">
            <p>
            Por gentileza, confirme a situação da sua hierarquia no sistema.
            </p>

            <b-form-group>
            <b-form-radio
                v-model="form.hierarquia_ok"
                :value="true"
                name="hierarquia"
            >
                <strong>Sim, minha hierarquia está correta.</strong><br>
                <small>
                Confirmo que as informações estão atualizadas e não há necessidade de ajustes.
                </small>
            </b-form-radio>

            <b-form-radio
                v-model="form.hierarquia_ok"
                :value="false"
                name="hierarquia"
                class="mt-3"
            >
                <strong>Não, identifiquei divergências na hierarquia.</strong><br>
                <small>
                Ao selecionar esta opção, nossa equipe entrará em contato para realizar
                a normalização o mais breve possível.
                </small>
            </b-form-radio>

            <div v-if="$v.form.hierarquia_ok.$error" class="invalid-feedback d-block mt-2">
                A confirmação da hierarquia é obrigatória.
            </div>
            </b-form-group>

            <p class="mt-3 mb-0">
            Sua confirmação é essencial para garantir a integridade dos dados e o correto
            funcionamento dos processos operacionais.
            </p>

            <p class="mt-2 mb-0">
            <strong>Agradecemos pela colaboração.</strong>
            </p>
        </div>
      </div>
      <!-- BOTÃO -->
      <b-button
        variant="default"
        class="btn-lg btn-block"
        :disabled="loading"
        @click="submit"
      >
        Salvar Atualização
        <b-spinner v-if="loading" small class="ml-2" />
      </b-button>

    </div>
  </Layout>
</template>
